import React from 'react';
import { Button, Result } from 'antd';
import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import { findLicenseProduct } from '../../services/tenant/providerBilling';

/**
 * What the partner sees after subscribing: which restaurant, which plan, and
 * when the free period ends. Shown in place of the modal body rather than as a
 * toast, because the trial end date is the one fact a partner will want to
 * read twice. `title` lets a trigger name its own outcome ("Bella is live!").
 */
export default function LicenseActivatedResult({
  company,
  entitlements,
  productKey,
  title = null,
  onContinue = () => {},
}) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:ProviderBilling:LicenseActivatedResult' });

  const product = findLicenseProduct(entitlements, productKey);
  // The backend names the day in the partner's billing calendar; formatting
  // the instant here, in the restaurant's timezone, could name another day.
  const trialEnd = product?.trial_ends_on ? moment(product.trial_ends_on).format('LL') : null;

  const address = [company?.address, company?.city].filter(Boolean).join(', ');

  return (
    <Result
      status="success"
      data-testid="license-activated"
      title={title ?? t('title', { plan: product?.name })}
      subTitle={
        <>
          <div>{company?.name}</div>
          {address && <div className="text-brand-inkGrey-grey_3">{address}</div>}
          <div data-testid="license-activated-plan">{t('plan', { plan: product?.name })}</div>
          {trialEnd && <div data-testid="license-activated-trial">{t('free_until', { date: trialEnd })}</div>}
        </>
      }
      extra={
        <Button type="primary" data-testid="license-activated-continue" onClick={onContinue}>
          {t('continue')}
        </Button>
      }
    />
  );
}
